'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import get from 'hs-lodash/get';
import IconResultSection from '../result/IconResultSection';
import RadialResultSection from '../result/RadialResultSection';
import YesNoResultSection from '../result/YesNoResultSection';
import FlipCardResultSection from '../result/FlipCardResultSection';

var ResultSection = function ResultSection(_ref) {
  var results = _ref.results,
      websiteGrade = _ref.websiteGrade;
  return results.map(function (result, index) {
    // Init the result with the grade
    result.init(get(websiteGrade, result.resultKeyPath));
    result.key = index; // Determine the correct ResultSection component to use to display the result

    if (result.progressBarIcon) {
      return /*#__PURE__*/_jsx(RadialResultSection, Object.assign({}, result));
    } else if (result.resultIcon) {
      return /*#__PURE__*/_jsx(IconResultSection, Object.assign({}, result));
    } else if (result.resultFlipCard) {
      return /*#__PURE__*/_jsx(FlipCardResultSection, Object.assign({}, result));
    } else {
      return /*#__PURE__*/_jsx(YesNoResultSection, Object.assign({}, result));
    }
  });
};

export default ResultSection;